"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title"],
  _excluded2 = ["aria-hidden"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.875 1.125v-1C12.217.125 15.75 3.658 15.75 8c0 4.342-3.533 7.875-7.875 7.875C3.533 15.875 0 12.342 0 8c0-2.071.804-4.021 2.228-5.484H.044v-1h3.474a.5.5 0 0 1 .5.5V5.49h-1V3.137A6.843 6.843 0 0 0 1 8a6.883 6.883 0 0 0 6.875 6.875A6.883 6.883 0 0 0 14.75 8a6.883 6.883 0 0 0-6.875-6.875Zm2.932 9.314-.734.68-2.565-2.78A.499.499 0 0 1 7.375 8V3.431h1v4.374l2.432 2.634Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.945 1.313V.188C18.46.188 23.758 5.486 23.758 12c0 6.514-5.299 11.813-11.813 11.813S.133 18.512.133 12c0-3.273 1.345-6.339 3.7-8.566H0V2.31h5.299c.31 0 .562.252.562.563V8.17H4.736V4.13A10.63 10.63 0 0 0 1.258 12c0 5.893 4.795 10.688 10.687 10.688 5.893 0 10.688-4.795 10.688-10.688 0-5.893-4.795-10.688-10.688-10.688Zm4.327 14.544-.827.764-3.913-4.24a.564.564 0 0 1-.15-.38V5.03h1.126v6.75l3.764 4.077Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.927 1.75V.25c8.685 0 15.75 7.065 15.75 15.75 0 8.685-7.065 15.75-15.75 15.75C7.242 31.75.177 24.685.177 16A15.66 15.66 0 0 1 5.11 4.579H0v-1.5h7.065a.75.75 0 0 1 .75.75v7.065h-1.5V5.508C3.367 8.208 1.677 11.973 1.677 16c0 7.857 6.393 14.25 14.25 14.25s14.25-6.393 14.25-14.25-6.393-14.25-14.25-14.25Zm5.769 19.393-1.103 1.018-5.217-5.652a.752.752 0 0 1-.199-.509V6.706h1.5v9l5.019 5.437Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.237 2.059V.187C37.34.188 48 10.848 48 23.95c0 13.103-10.66 23.763-23.763 23.763C11.134 47.713.475 37.053.475 23.95c0-6.75 2.82-13.082 7.783-17.586H0V4.492h10.752c.516 0 .935.42.935.936V16.18h-1.87V7.488A21.791 21.791 0 0 0 2.345 23.95c0 12.071 9.82 21.892 21.891 21.892 12.071 0 21.892-9.821 21.892-21.892 0-12.07-9.821-21.891-21.892-21.891Zm8.628 29.859-1.375 1.268-7.94-8.601a.932.932 0 0 1-.248-.634V9.807h1.87v13.778l7.692 8.333Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.316 2.745V.25C49.786.25 64 14.463 64 31.934c0 17.47-14.213 31.683-31.684 31.683-17.47 0-31.683-14.213-31.683-31.683A31.54 31.54 0 0 1 11.01 8.484H0V5.99h14.336c.688 0 1.247.559 1.247 1.247v14.336H13.09V9.983c-6.342 5.553-9.962 13.481-9.962 21.95 0 16.095 13.095 29.19 29.19 29.19 16.094 0 29.188-13.095 29.188-29.19 0-16.094-13.094-29.188-29.189-29.188ZM43.82 42.557l-1.833 1.691L31.4 32.78a1.243 1.243 0 0 1-.331-.845V13.077h2.494v18.37l10.256 11.11Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconTime = function IconTime(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    title = _ref.title,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _props$ariaHidden = props["aria-hidden"],
    ariaHidden = _props$ariaHidden === void 0 ? 'true' : _props$ariaHidden,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  var finalAriaHidden = (title ? false : ariaHidden).toString();
  var finalTitle = finalAriaHidden === 'false' ? title || 'Time' : null;
  if (title && (ariaHidden === true || ariaHidden === 'true') && process.env.NODE_ENV !== 'production') {
    console.warn('Passing a custom title will set the aria-hidden attribute to false within IconTime. Consider passing aria-hidden="false" explicitly to IconTime for compatibility with future versions.');
  }
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: finalTitle,
    "aria-hidden": finalAriaHidden
  }, rest, {
    iconClass: "Time"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconTime.sizes = [16, 24, 32, 48, 64];
IconTime.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = exports.default = IconTime;